// import { Deg2Rad } from "../math/MathEx.js";
// import { Quaternion } from "../math/Quaternion.js";
// import { Vector3 } from "../math/Vector3.js";
// Angle between J2000 mean equator and the ecliptic plane.
// 23 deg 26' 21".448 (Seidelmann, _Explanatory Supplement to the
// Astronomical Almanac_ (1992), eqn 3.222-1.
export const J2000ObliquityDeg = 23.4392911;
// export const J2000EquatorFrameRotD: Quaternion = Quaternion.AngleAxis(
//     J2000ObliquityDeg * Deg2Rad,
//     Vector3.Right(),
// );
// export const J2000EclipticFrameRotD: Quaternion = Quaternion.Identity();
// export const J2000EquatorFrameRot = Quaternion.AngleAxis(
//     J2000ObliquityDeg,
//     Vector3.Right(),
// );
// export const J2000EclipticFrameRot = new Quaternion(0, 0, 0, 1.0);
// export const J2000ToVsop87Rot: Quaternion = Quaternion.XRotation(
//     -23.4392803055555555556 * Deg2Rad,
// ).multiply(Quaternion.ZRotation(0.0000275 * Deg2Rad));
// export const Vsop87ToJ2000Rot = J2000ToVsop87Rot.invert();
// export const GalaxyRotation = Quaternion.AngleAxis(44.47, Vector3.Up())
//     .multiply(Quaternion.AngleAxis(45.16, Vector3.Right()))
//     .multiply(Quaternion.AngleAxis(120.9, Vector3.Forward()));
// export const GalaToScreen = GalaxyRotation.multiply(
//     Quaternion.AngleAxis(180, Vector3.Up()),
// ).multiply(Quaternion.AngleAxis(-90, Vector3.Right()));
// export const StarDistance = 23455 * 1e4;
// export const AsteroidBeltRadius = 7e4;
// export const KuiperBeltRadius = 1e6;
// export const KuiperBeltRadiusForScale = 1.4e6;
// export const GalaStarToScreenCoef = 0.6 * StarDistance;
// export const GalaLabelToScreenCoef = GalaStarToScreenCoef;
export const J2000 = 2451545.0;
// export const J0001 = 1721423.77016;
// export const J2001 = 2451910.5;
// jd2000
// export const P03LpValidCenturies = 5000.0;
// export const EarthAxisConstantObliquity = 23.439281;
// export const G = 6.672e-11;
// export const SolarMass = 1.989e30;
// export const EarthMass = 5.976e24;
// export const LunarMass = 7.354e22;
export const EarthRadiusKM = 6371;
export const EarthRadiusKMInverse = 1.0 / EarthRadiusKM;
export const KmPerAu = 149597870.7;
export const AU = KmPerAu / EarthRadiusKM;
export const kAU = EarthRadiusKMInverse;
// export const AuPerLy = 63241.077;
export const AuPerParsec = 206264.806;
// speed of light (km/sec)
export const SpeedOfLight = 299792.458;
// speed of light (km/day)
// export const SpeedOfLightPerDay = SpeedOfLight * 86400.0;
// export const AUtoKilometers = (au: number): number => {
//     return au * KmPerAu;
// };
export const DT = 1 / 86400;
// export const Pericenter = (
//     semiMajorAxis: number,
//     eccentricity: number,
// ): number => {
//     return semiMajorAxis * (1 - eccentricity) * KmPerAu;
// };
export const intervals = [
    1.0 / 50,
    1.0 / 600,
    1.0 / 7200,
    1.0 / 86400,
    // 1.0 / 2,
    // 1.0 / 4,
    // 1.0 / 8,
    // 1.0 / 16,
    // 1.0 / 32,
    // 1.0 / 64,
    // 1.0 / 128,
    // 1.0 / 256,
    // 1.0 / 512,
    // 1.0 / 1024,
    // 1.0 / 2048,
    // 1.0 / 4096,
    // 1.0 / 8192,
    // 1.0 / 16384,
    // 1.0 / 32768,
    // 1.0 / 43200,
    // 1.0 / 86400,
];
